import { forwardRef, memo, useCallback, useState } from "react";
import classNames from "classnames";
import { Checkbox } from "../Checkbox";
import { TextField, TextFieldProps } from "../TextField";
import { EyeButton } from "./EyeButton";

import styles from "./style.module.scss";

export type PasswordFieldProps = TextFieldProps & {
  showEyeIcon?: boolean,
  showCheckBox?: boolean,
  inputContainerClassName?: string,
}

const PasswordField = memo(forwardRef<HTMLInputElement, PasswordFieldProps>((
  {
    showEyeIcon,
    showCheckBox,
    inputContainerClassName,
    ...props
  }, ref) => {
  const [ isShownPassword, setIsShownPassword ] = useState(false);

  const onEyeBtnClick = useCallback(
    () => setIsShownPassword(state => !state),
    [ setIsShownPassword ],
  );

  return (
    <div className={classNames(inputContainerClassName, styles.container, { [styles.withCheckbox]: showCheckBox })}>
      <TextField
        ref={ref}
        type={isShownPassword ? "text" : "password"}
        endAdornment={
          <>
            {
              !!showEyeIcon &&
              <EyeButton
                isShownPassword={isShownPassword}
                onClick={onEyeBtnClick}
                disabled={props.disabled}
              />
            }
            {props.endAdornment}
          </>
        }
        {...props}
      />
      {
        !!showCheckBox &&
        <Checkbox
          value={isShownPassword}
          onChange={onEyeBtnClick}
          label={"Show password"}
          disabled={props.disabled}
          className={styles.checkbox}
        />
      }
    </div>
  );
}));

export default PasswordField;
